//archivo ApiKey.js
export default { 
	USER_ID: 'Eqd24BnMSZ5dCHS4w', 
	TEMPLATE_ID: 'template_qzj69v5',
	SERVICE_ID: 'service_ejy8w0l'
}